import API from '../services/api';
import React, { useState, useEffect } from 'react';
import { FaTimes, FaSave, FaUserEdit } from 'react-icons/fa';
import './TopupModal.css';;   // Create this CSS file


const EditModal = ({ isOpen, onClose, userDetails, onConfirm }) => {

    const [formData, setFormData] = useState({
        name: '',
        user_status: '',
        profile_status: '',
        stake_status: '',
        withdraw_status: '',
        month_roi: '',
    });

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    // Populate form when modal opens
    useEffect(() => {
        if (isOpen && userDetails) {
            setFormData({
                user_id: userDetails.id,
                name: userDetails.name || '',
                user_status: userDetails.user_status || 'active',
                profile_status: userDetails.profile_status || 'active',
                stake_status: userDetails.stake_status || 'active',
                withdraw_status: userDetails.withdraw_status || 'enable',
                month_roi: userDetails.monthly_roi_limit || '',
            });
            setError('');
            setSuccess('');
        }
    }, [isOpen, userDetails]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        setSuccess('');

        try {
            const response = await API.post('/admin/user/edit', formData);

            return response.data;
        } catch (err) {
            setError(err.response?.data?.message || err.message || 'Something went wrong');
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content edit-modal" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h2>
                        <FaUserEdit /> Edit User Information
                    </h2>
                    <button className="modal-close" onClick={onClose} disabled={loading}>
                        <FaTimes />
                    </button>
                </div>

                <div className="modal-body">
                    {error && <p className="error-message">{error}</p>}
                    {success && <p className="success-message">{success}</p>}

                    <form onSubmit={handleSubmit}>
                        <div className="form-grid">

                            {/* Name */}
                            <div className="form-group">
                                <label>Name</label>
                                <input
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                />
                            </div>



                            {/* User Status */}
                            <div className="form-group">
                                <label>User Status</label>
                                <select name="user_status" value={formData.user_status} onChange={handleChange} required>
                                    <option value="active">Active</option>
                                    <option value="hold">Hold</option>
                                    <option value="block">Blocked</option>
                                </select>
                            </div>

                            {/* Profile Status */}
                            <div className="form-group">
                                <label>Profile Status</label>
                                <select name="profile_status" value={formData.profile_status} onChange={handleChange} required>
                                    <option value="active">Active</option>
                                    <option value="pending">Pending</option>
                                </select>
                            </div>

                            {/* Stake Status */}
                            <div className="form-group">
                                <label>Trade Status</label>
                                <select name="stake_status" value={formData.stake_status} onChange={handleChange} required>
                                    <option value="active">Active</option>
                                    <option value="pending">Pending</option>
                                </select>
                            </div>

                            {/* Withdraw Status */}
                            <div className="form-group">
                                <label>Withdraw Status</label>
                                <select name="withdraw_status" value={formData.withdraw_status} onChange={handleChange} required>
                                    <option value="enable">Enable</option>
                                    <option value="disable">Disable</option>
                                </select>
                            </div>

                            {/* Month ROI */}
                            <div className="form-group">
                                <label>Month ROI (%)</label>
                                <input
                                    type="number"
                                    name="month_roi"
                                    value={formData.month_roi}
                                    onChange={handleChange}
                                    step="0.01"
                                    placeholder="e.g. 5.5"
                                />
                            </div>

                        </div>

                        <div className="modal-actions">
                            <button
                                type="button"
                                className="btn-cancel"
                                onClick={onClose}
                                disabled={loading}
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                className="btn-confirm"
                                disabled={loading}
                            >
                                {loading ? 'Updating...' : <><FaSave /> Update User</>}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default EditModal;